import { Component, inject } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
	selector: 'app-allergens-info-modal',
	templateUrl: './allergens-info-modal.component.html',
	styleUrls: ['./allergens-info-modal.component.scss'],
	standalone: false,
})
export class AllergensInfoModalComponent {
	private modalCtrl = inject(ModalController);

	static async show(modalCtrl: ModalController) {
		const modal = await modalCtrl.create({
			component: AllergensInfoModalComponent,
			cssClass: 'auto-height item-modal reduced-width-modal',
			showBackdrop: true,
			backdropDismiss: true,
		});
		return await modal.present();
	}

	closeReceiptError() {
		this.modalCtrl.dismiss();
	}
}
